'use strict';

var React = require('react');

var SvgInviteMinor = function SvgInviteMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.567 7.57a.75.75 0 0 0-.634 1.36l3.538 1.651a1.25 1.25 0 0 0 1.058 0l3.538-1.651a.75.75 0 0 0-.634-1.36l-3.433 1.603-3.433-1.602Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.75 4.5a3.75 3.75 0 0 0-3.75 3.75v3.5a3.75 3.75 0 0 0 3.75 3.75h6.5a3.75 3.75 0 0 0 3.75-3.75v-3.5a3.75 3.75 0 0 0-3.75-3.75h-6.5Zm-2.25 3.75a2.25 2.25 0 0 1 2.25-2.25h6.5a2.25 2.25 0 0 1 2.25 2.25v3.5a2.25 2.25 0 0 1-2.25 2.25h-6.5a2.25 2.25 0 0 1-2.25-2.25v-3.5Z"
  }));
};
SvgInviteMinor.displayName = "InviteMinor";

exports.SvgInviteMinor = SvgInviteMinor;
